import { useEffect, useState } from "react";

import type { PrescriptionBump } from "../../../shared/src";

interface Props {
  bumps: PrescriptionBump[];
  onDismiss: () => void;
  autoDismissMs?: number;
}

function formatBumpLine(bump: PrescriptionBump): string {
  const before: string[] = [];
  const after: string[] = [];
  if (bump.weight_kg) {
    before.push(`${bump.weight_kg.before ?? "—"} kg`);
    after.push(`${bump.weight_kg.after} kg`);
  }
  if (bump.reps) {
    before.push(`${bump.reps.before ?? "—"} reps`);
    after.push(`${bump.reps.after} reps`);
  }
  if (bump.sets) {
    before.push(`${bump.sets.before ?? "—"} sets`);
    after.push(`${bump.sets.after} sets`);
  }
  return `${bump.exercise_name}: ${before.join(" × ")} → ${after.join(" × ")}`;
}

export function BumpToast({ bumps, onDismiss, autoDismissMs = 5000 }: Props) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = window.setTimeout(() => {
      setVisible(false);
      onDismiss();
    }, autoDismissMs);
    return () => window.clearTimeout(t);
  }, [autoDismissMs, onDismiss]);

  if (!visible || bumps.length === 0) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      onClick={() => {
        setVisible(false);
        onDismiss();
      }}
      className="fixed inset-x-4 bottom-4 z-50 cursor-pointer rounded-2xl border border-orange-500 bg-slate-900/95 p-4 shadow-lg ring-1 ring-orange-500/40 sm:left-auto sm:right-4 sm:max-w-md"
    >
      <div className="mb-1 text-sm font-semibold text-orange-400">
        Program updated
      </div>
      <ul className="space-y-1">
        {bumps.map((bump) => (
          <li key={bump.day_exercise_id} className="text-sm text-slate-200">
            {formatBumpLine(bump)}
          </li>
        ))}
      </ul>
    </div>
  );
}
